(function () {
  var SPACING = 350;
  var LEGIBILITY_FLOOR = 0.35;
  var MAX_BLUR = 1.6;
  var MIN_SCALE = 0.62;
  var HELIX_Z = 5;

  function initHero(root) {
    var ring = root.querySelector('[data-hero-ring]');
    var dotsEl = root.querySelector('[data-hero-dots]');
    if (!ring || !dotsEl) return;

    var cardEls = Array.prototype.slice.call(root.querySelectorAll('[data-hero-card]'));
    var n = cardEls.length;
    if (n === 0) return;

    var current = 0;
    var timer = null;
    var isSimple = false;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    cardEls.forEach(function (el, i) {
      el.addEventListener('click', function (e) {
        if (i !== current) {
          e.preventDefault();
          goTo(i);
        }
      });
    });

    var dotEls = cardEls.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'a2k-interactive-hero__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Show hero message ' + (i + 1));
      b.addEventListener('click', function () {
        goTo(i);
      });
      dotsEl.appendChild(b);
      return b;
    });

    function updateCardStyles() {
      cardEls.forEach(function (el, i) {
        var diff = i - current;
        diff = ((diff % n) + n) % n;
        if (diff > n / 2) diff -= n;
        var absDiff = Math.abs(diff);

        var scale = Math.max(MIN_SCALE, 1 - absDiff * 0.18);
        var opacity = Math.max(LEGIBILITY_FLOOR, 1 - absDiff * 0.32);
        var blur = Math.min(MAX_BLUR, absDiff * 0.9);
        var zIndex = absDiff <= 1 ? HELIX_Z + 5 + Math.round((2 - absDiff) * 40) : Math.max(0, HELIX_Z - 1 - absDiff);

        el.style.transform = 'translate(-50%, -50%) translateX(' + (diff * SPACING).toFixed(0) + 'px) scale(' + scale.toFixed(2) + ')';
        el.style.opacity = opacity.toFixed(2);
        el.style.filter = 'blur(' + blur.toFixed(1) + 'px)';
        el.style.zIndex = zIndex;
      });
    }

    function render() {
      if (isSimple) {
        cardEls.forEach(function (el, i) {
          el.classList.toggle('is-current', i === current);
        });
      } else {
        updateCardStyles();
      }
      dotEls.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function goTo(i) {
      current = i;
      render();
      resetTimer();
    }

    function advance() {
      current = (current + 1) % n;
      render();
    }

    function resetTimer() {
      if (timer) clearInterval(timer);
      if (n > 1) timer = setInterval(advance, interval);
    }

    var mql = window.matchMedia('(max-width: 749px)');

    function applyMode() {
      isSimple = mql.matches;
      root.classList.toggle('is-simple', isSimple);
      if (isSimple) {
        cardEls.forEach(function (el) {
          el.style.transform = '';
          el.style.opacity = '';
          el.style.filter = '';
          el.style.zIndex = '';
        });
      }
      render();
    }

    if (mql.addEventListener) {
      mql.addEventListener('change', applyMode);
    } else if (mql.addListener) {
      mql.addListener(applyMode);
    }

    root.addEventListener('mouseenter', function () {
      if (timer) clearInterval(timer);
    });
    root.addEventListener('mouseleave', resetTimer);

    applyMode();
    resetTimer();
  }

  document.querySelectorAll('[data-a2k-interactive-hero]').forEach(initHero);
})();
